import { cn } from 'lib/utils';
import { Icon } from 'components/ui/icon';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/ui/tooltip';

export interface IHeaderProps {
  heading?: string | JSX.Element;
  subHeading?: string | JSX.Element;
  className?: string;
  tooltipText?: string;
  level?: 'h1' | 'h2';
  overrideContainerClass?: boolean;
  headingAppendRight?: JSX.Element;
}

const PageHeading = ({
  heading,
  subHeading,
  className,
  tooltipText,
  level = 'h1',
  overrideContainerClass = false,
  headingAppendRight,
}: IHeaderProps): JSX.Element => {
  return (
    <div className={cn(!overrideContainerClass && 'mb-4', className)}>
      <div className="flex items-center">
        {heading && (
          <>
            {level === 'h1' && (
              <h1
                id="page-heading"
                className={cn(
                  'font-semibold text-2xl leading-8 text-gray-blue-90',
                  subHeading && 'mb-1'
                )}
              >
                {heading}
              </h1>
            )}
            {level === 'h2' && (
              <h2
                id="page-heading"
                className={cn(
                  'font-semibold text-base leading-6 text-gray-blue-80',
                  subHeading && 'mb-1'
                )}
              >
                {heading}
              </h2>
            )}
          </>
        )}
        {headingAppendRight}
      </div>
      {subHeading && (
        <div className="font-normal text-sm leading-5 text-gray-blue-70">
          {subHeading}
          {tooltipText && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <span className="pl-1 inline-flex cursor-help">
                    <Icon
                      name="info"
                      size={16}
                      className="text-gray-blue-50"
                      data-testid="tooltip-icon"
                    />
                  </span>
                </TooltipTrigger>
                <TooltipContent side="right">
                  <p>{tooltipText}</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </div>
      )}
    </div>
  );
};

export default PageHeading;
